import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

export const sideLoadedBusinessSerializeMap: SerializeMap<SideLoadedBusiness> =
  {
    id: "id",
    name: "name",
    abn: "abn",
    isUsed: "is_used",
    rawData: "raw_data",
    datasetName: "dataset_name",
    businessIds: "business_ids",
  };

export const serializeSideLoadedBusiness = buildSerializer(
  sideLoadedBusinessSerializeMap,
  "sideLoadedBusiness",
);

export const deserializeSideLoadedBusiness = buildDeserializer(
  sideLoadedBusinessSerializeMap,
  "sideLoadedBusiness",
);
